import NoDataIcon from "../../assets/NoDataIcon";

export default function NoDataComponent(props: any) {
  const { width, height } = props;
  return (
    <div className="flex justify-center items-center h-full">
      <div className="flex flex-col justify-center items-center gap-2">
        <NoDataIcon width={width} height={height} />
        <span className="font-bold -ml-[37px]">NO DATA AVAILABLE </span>
      </div>
    </div>
  );
}
